import React, {useEffect, useMemo, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Step, StepLabel, Stepper} from "@mui/material";
import {Box} from "@mui/system";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import DetailTable from "../table/cutting/details/DetailTable";
import {DetailFilterData} from "../../../data/FilterTables/DetailFilterData";
import CircularProgress from "@mui/material/CircularProgress";
import ButtonBack from "../button/ButtonBack";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import {typeRelateDetail} from "../../../data/ TypeRelateDetail";


const AddDetailBasedOnDetail = ({modalOpen, handleClose, handleSubmit, handleModalAlert, loading, api, relate}) => {
    const ComponentDetailWithFilter = useMemo(() => {
        return withFilter(DetailTable, DetailFilterData);
    }, []);
    const typeRelateDetailList = Object.entries(typeRelateDetail)
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState([]);
    const [rowSelection, setRowSelection] = useState(null);
    const [activeStep, setActiveStep] = useState(0)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 20,
        totalElements: 0,
        searchData: ""
    })
    const [values, setValues] = useState({name: "", typeComposition: typeRelateDetailList[0][0]})
    const [validationState, setValidationState] = useState({name: ""})

    useEffect(() => {
        modalOpen && api().then(function (response) {
            let data = response.data;
            setData(data);
            setRowSelection(data[0])
            setTableOptions((prev) => ({...prev, totalElements: data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setIsLoading(false))
    }, [modalOpen]);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }
    const close = () => {
        handleClose()
        setValues({name: "", typeComposition: typeRelateDetailList[0][0]})
        setActiveStep(0)
    }
    const submit = () => {
        if (activeStep === 0 && relate) {
            setActiveStep(1)
        } else if (relate) {
            const newErrors = {...validationState}
            Object.entries(values).forEach(([name, value]) => {
                if (value === "") {
                    newErrors[name] = "пустое поле"
                }
            })
            setValidationState(newErrors)
            if (Object.values(newErrors).every(el => el === "")) {
                handleSubmit(rowSelection, values, close)
            }
        } else {
            handleSubmit(rowSelection, close)
        }
    }
    return (
        <Dialog open={modalOpen} PaperProps={{
            style: {
                minWidth: activeStep === 0 ? "1500px" : "600px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">Добавить деталь</DialogTitle>
            {relate &&
                <Box sx={{display: "flex", justifyContent: "center"}}>
                    <Stepper
                        style={{width: activeStep === 0 ? 600 : 550}}
                        activeStep={activeStep}
                    >
                        {["Детали", "Тип и наименование"].map((label) => (
                            <Step key={label}>
                                <StepLabel sx={{
                                    ".MuiSvgIcon-root": {
                                        fontSize: 40,
                                        color: "#737478",
                                        "&.Mui-active": {
                                            color: "#3B8BEC",
                                        }
                                    },
                                    "& .MuiStepLabel-label": {
                                        fontSize: 18,
                                        "&.Mui-active": {
                                            fontWeight: 700,
                                        }
                                    }
                                }}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>}
            <DialogContent>
                {(activeStep === 0) ? isLoading ?
                    <Box sx={{
                        height: `630px`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CircularProgress disableShrink/>
                    </Box> : <Box sx={{padding: "0 0px"}}>
                        <ComponentDetailWithFilter
                            data={data}
                            setData={setData}
                            selectedString={rowSelection}
                            setSelectedString={setRowSelection}
                            isColumnMaterial={false}
                            isColumnOrder={false}
                            isDetailModel={true}
                            isButtonAddDetail={true}
                            warehouse={'orders'}
                            enableGrouping={false}
                            columnGrouping={[]}
                            expanded={false}
                            enableEditing={true}
                            handleModalAlert={handleModalAlert}
                            tableOptions={tableOptions}
                            tableOptionsHandle={tableOptionsHandle}
                            isModal={true}
                        />
                    </Box> : <Box> <TextFieldValidation
                    name={"name"}
                    type={"text"}
                    value={values?.name}
                    label={"Наименование"}
                    setCurrValues={setValues}
                    validationError={validationState?.name}
                    setValidationState={setValidationState}
                />
                    <TextFieldValidation
                        select
                        label="Тип"
                        value={values?.typeComposition}
                        setCurrValues={(getData) => setData(prev => ({
                            ...prev,
                            typeComposition: getData()
                        }))}
                        width={"550px"}
                        required={false}
                    >
                        {typeRelateDetailList?.map((option) => (
                            <MenuItem key={option[0]} value={option[0]}>
                                {option[1]}
                            </MenuItem>
                        ))}
                    </TextFieldValidation>
                </Box>}
            </DialogContent>
            <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep === 1 && <ButtonBack text={"Назад"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit
                        text={"Отменить"} onClick={close}/>
                    <ButtonAdd
                        loading={loading || isLoading}
                        text={(activeStep === 0 && relate) ? "Выбрать" : "Добавить"}
                        onClick={submit}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
};
export default AddDetailBasedOnDetail